module.exports = __webpack_public_path__ + "img/P.df278cac.jpg";